export default __webpack_public_path__ + "static/media/30_SchererGruppe-DTM-Documentary-EschweilerPhotography_M1A3135.d7827799.jpg";